export default __webpack_public_path__ + "30a713e140081fb55fc5fe308ad21a62.svg";